import React from 'react';

const Score = ({ score, total, questions, onRestart, onBack }) => {
  const percentage = total > 0 ? Math.round((score / total) * 100) : 0;

  return (
    <div className="container mt-3">
      <div className="card p-3">
        <div className="quizcard-body">
          <h2 className="card-title text-center mb-3">Quiz Completed!</h2>

          <h4 className="card-text text-center mb-2">
            Your score: {score} / {total} ({percentage}%)
          </h4>

          <div className="d-flex justify-content-center gap-2 mb-4">
            <button className="btn btn-primary" onClick={onRestart}>
              Retry This Quiz
            </button>
            <button className="btn btn-outline-secondary" onClick={onBack}>
              Choose Another Quiz
            </button>
          </div>

          <h5 className="mb-3">Review</h5>
          <div className="row">
            {questions.map((q, index) => (
              <div key={index} className="col-md-6 mb-3">
                <p className="mb-1">
                  <strong>Q{index + 1}:</strong> {q.question}
                </p>
                <p className="mb-1 text-success">
                  <strong>Answer:</strong> {q.answer}
                </p>
                {q.explanation && (
                  <p className="mb-0 text-muted">
                    <em>{q.explanation}</em>
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Score;